import { render, staticRenderFns } from "./AIAssistant.vue?vue&type=template&id=0fcfda7f&scoped=true&"
import script from "./AIAssistant.vue?vue&type=script&lang=ts&"
export * from "./AIAssistant.vue?vue&type=script&lang=ts&"
import style0 from "./AIAssistant.vue?vue&type=style&index=0&id=0fcfda7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcfda7f",
  null
  
)

export default component.exports